"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createD2CMessage = void 0;
const effect_1 = require("effect");
const message_1 = require("./message");
const createD2CMessage = (namespace, events) => {
    const LegacyEvent = effect_1.Schema.Union(...events.map(({ fields: { _tag, ...fields } }) => effect_1.Schema.Struct({ eventName: _tag, ...fields })));
    const Event = effect_1.Schema.encodedBoundSchema(LegacyEvent).pipe(effect_1.Schema.transform(effect_1.Schema.Union(...events), {
        strict: false,
        decode: ({ eventName, ...event }) => ({ _tag: eventName, ...event }),
        encode: ({ _tag, ...rest }) => ({ eventName: _tag, ...rest }),
    }));
    return (0, message_1.createMessage)('event', Event).annotations({
        identifier: `${namespace}.EventD2CMessage`,
        title: 'Event Message',
        description: 'A Device-To-Cloud message on the "event" channel',
    });
};
exports.createD2CMessage = createD2CMessage;
//# sourceMappingURL=event.js.map